export default __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.4a8138d.eot";